import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferTidalToYoutubeMusic() {
    return (
        <GuidesPage
            seoData={seoContent.transferTidalToYoutubeMusic}
            sections={<PairTransferGuideContent sourceKey="tidal" destKey="youtubeMusic" />}
        />
    );
}
